// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import classnames from 'classnames';
import CampaignVersionPicker from './CampaignVersionPicker';
import VersionStatusHeader from './VersionStatusHeader';
import CampaignNameModal from './CampaignNameModal';
import {
  updateOrchestrationName,
  getOrchestrationVersion
} from '../actions/api';
import { duplicateOrchVersionAndCreatives } from '../actions/chainedApi';
import { type OrchestrationVersion } from '../constants/ApiTypes';
import { ALL_PATH } from '../util/RouterUtils';

type Props = {
  campaignName: string,
  orchestrationVersions: { [number]: OrchestrationVersion },
  getOrchestrationVersion: Function,
  orchestrationId: number,
  versionId: number,
  orgId: number,
  editable: boolean,
  updateOrchestrationName: Function,
  duplicateOrchVersionAndCreatives: Function,
  creatives: Array<any>, // FIXME
  location: Object,
  history: Object
};

type State = {
  showCampaignNameModal: boolean
};

type LogoProps = {
  onClick: Function
};

const Logo = (props: LogoProps) => (
  <svg className="Logo" onClick={props.onClick}>
    <use x="23" y="22" fill="#54565C" xlinkHref="#logo" />
  </svg>
);

class CampaignNameHeader extends Component<Props, State> {
  state = { showCampaignNameModal: false };

  toggleModal(flag: string) {
    if (this.props.editable) {
      this.setState({ [flag]: !this.state[`${flag}`] });
    }
  }

  render() {
    const {
      campaignName,
      orchestrationVersions,
      orchestrationId,
      versionId,
      orgId,
      location,
      history
    } = this.props;
    const currentIds = { orchestrationId, versionId, orgId };

    return (
      <div>
        <div
          className={classnames('Page__Header', {
            'Page__Header--editable': this.props.editable
          })}
        >
          <Logo
            onClick={() =>
              history.push({ pathname: ALL_PATH, search: location.search })
            }
          />
          <div
            className="Page__Header__Name"
            onClick={() => this.toggleModal('showCampaignNameModal')}
            onKeyDown={() => {}}
            tabIndex="-1"
            role="button"
            style={{ outline: 0, lineHeight: '32px' }}
          >
            {campaignName}
          </div>
          <CampaignVersionPicker
            key={versionId}
            orchestrationVersions={orchestrationVersions}
            createOrchestrationVersion={
              this.props.duplicateOrchVersionAndCreatives
            }
            orchestrationVersionId={versionId}
            orgId={orgId}
            orchestrationId={orchestrationId}
            getOrchestrationVersion={this.props.getOrchestrationVersion}
            creatives={this.props.creatives}
          />
          <VersionStatusHeader {...currentIds} />
        </div>
        <CampaignNameModal
          campaignName={campaignName}
          showModal={this.state.showCampaignNameModal}
          onCloseCallback={() => this.toggleModal('showCampaignNameModal')}
          orchestrationId={orchestrationId}
          orgId={orgId}
          updateOrchestrationName={this.props.updateOrchestrationName}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { orchestrationId } = ownProps;
  return {
    orchestrationVersions: state.api.versionsByOrchestrationId[orchestrationId],
    campaignName:
      (state.api.orchestrationsById[orchestrationId] &&
        state.api.orchestrationsById[orchestrationId].name) ||
      'Untitled',
    creatives: state.api.creatives
  };
};

const mapDispatchToProps = {
  duplicateOrchVersionAndCreatives,
  updateOrchestrationName,
  getOrchestrationVersion
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CampaignNameHeader)
);



// WEBPACK FOOTER //
// ./src/components/CampaignNameHeader.jsx